module.exports = __webpack_public_path__ + "img/lp-NBC.4a952552.png";